import React from 'react';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Footer from '../components/footer';
import TeamCollaboration from '../components/teamCollaboration';
function TeamCollaborationPage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <TeamCollaboration />
        <Footer />
      </div>
    );
  }

 export default TeamCollaborationPage; 
  
  